import { ApolloClient, HttpLink, InMemoryCache, ApolloLink } from "@apollo/client";
import _fetch from "isomorphic-fetch";
import config from "../../utils/config";
import root from "window-or-global";

const api = `${config.apiUrl}/graphql.api`

const authLink = new ApolloLink(function(operation, forward) {
    console.log("authLink", arguments);
    const token = root?.localStorage?.getItem("authToken");
    if (token) {
      operation.setContext({
        headers: {
          authorization: token ? `Bearer ${token}` : "",
        },
      });
    }
    return forward(operation);
});

function merge(existing, incoming) {
  return {
    ...existing,
    ...incoming,
  };
}

const cacheSettings = {
  typePolicies: {
    QueryClassMethods: {
      merge(existing = {}, incoming) {
        const output = {
          ...existing,
        };
        Object.keys(incoming).forEach((k) => {
          if (existing[k] && k !== "__typename") {
            output[k] = merge(existing[k], incoming[k]);
          } else {
            output[k] = incoming[k];
          }
        });
        return output;
      },
    },
    QueryModels: {
      merge(existing = {}, incoming) {
        return {
          ...existing,
          ...incoming,
        };
      },
    },
    MutationClassMethods: {
      merge(existing = {}, incoming) {
        const output = {
          ...existing,
        };
        Object.keys(incoming).forEach((k) => {
          if (existing[k] && k !== "__typename") {
            output[k] = merge(existing[k], incoming[k]);
          } else {
            output[k] = incoming[k];
          }
        });
        return output;
      },
    },
    MutationModels: {
      merge(existing = {}, incoming) {
        return {
          ...existing,
          ...incoming,
        };
      },
    },
  },
};
const cache = new InMemoryCache(cacheSettings);

const client = new ApolloClient({
    credentials: "include",
    link: authLink.concat(new HttpLink({
        uri: api,
    })),
    cache,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
      },
      query: {
        fetchPolicy: "cache-first",
      },
    },
});

export default client;